import React, { Component } from 'react';
import { Link } from 'react-router-dom'

class About extends Component {
    render() {
        return(
            <section id="about">
                <div className="container h-100">
                    <div className="row align-items-center h-100">
                        <div className="col-xs-12 col-lg-6 mx-auto text-center">
                            <div className="section-title text-center">
                                <h2>Who Is <span>GrubRun?</span></h2>
                            </div>
                            <p className="white">With more features, a friendly interface, and a broad community of excited users,
                                GrubRun surpassess current competitors such as <a href="http://mealgame.com/about/">MealGame</a> and 
                                <a href="https://play.google.com/store/apps/details?id=com.spotluck&hl=en_US"> Spotluck </a>with class and efficiency.</p>
                            <Link to="/about" className="downloadbutton">Learn More</Link>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default About;